import { Address } from 'data-model';

export function formatAddress(address?: Address): string | undefined {
  if (!address) {
    return undefined;
  }

  const { countryCode: _, ..._address } = address;

  if (!Object.values(_address).some(key => !!key && key !== '')) {
    return undefined;
  }

  return [
    [address.street, address.streetNumber].filter(str => str && str.trim() !== '').join(' '),
    [address.zipCode, address.city].filter(str => str && str.trim() !== '').join(' '),
  ]
    .filter(str => str && str.trim() !== '')
    .join('\n');
}
